(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const api = () => window.GarnioDialog;
  const qa = document.querySelector('[data-quick-add-dialog]');
  const slot = qa && qa.querySelector('[data-quick-add-slot]');
  if (!qa) return;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || !api()) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`/products/${btn.dataset.quickAdd}?section_id=quick-add`, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = doc.querySelector('[data-quick-add-content]');
      if (!content) throw new Error('no content');
      slot.replaceChildren(content);
      api().open(qa, qa.querySelector('[data-autofocus]'));
    } catch (err) {
      window.location.href = `/products/${btn.dataset.quickAdd}`;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('cart:item-added', () => { if (qa.open) api().close(qa); });
})();
  } catch(e) { console.error(e); }
})();

})();
